// Hire developers pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const HIRE_NFT_DEVELOPERS_META_DATA: PageHeadMeta = {
    title: 'Hire NFT Developers | NFT Developers For Hire | Debut Infotech',
    img: cdnUrl('hire-nft-development/nft-marketplace-development-company.png'),
    description:
        'Debut Infotech boasts a team of seasoned NFT developers for hire that are skilled to provide tailored solutions for your NFT projects. Contact us for a free quote.'
};

export const HIRE_GENERATIVE_AI_ENGINEERS_META_DATA: PageHeadMeta = {
    title: 'Hire Generative AI Developers | Generative AI Engineer',
    img: cdnUrl('hire-generative-ai-engineers/gen-ai-engineer.png'),
    description:
        'Hire top-rated generative AI developers for your project. Our generative AI engineers excel at delivering bespoke AI solutions tailored to your specific needs.'
};

export const HIRE_AI_DEVELOPERS_META_DATA: PageHeadMeta = {
    title: 'Hire AI Developers | Hire Remote AI Developers | Hire AI Engineers',
    img: cdnUrl('hire-ai-developers/Hire-ai-developers.jpg'),
    description:
        'Hire AI developers to build cutting-edge AI solutions. Our AI engineers specialize in ML, NLP & automation. Get top AI talent for your project today'
};

export const HIRE_REMOTE_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Remote Developers | Top Talent for Your Project',
    description:
        'Looking to hire remote developers? Get top talent skilled in diverse technologies to boost your project within 48 hours. Schedule your consultation today!',
    img: cdnUrl('hire-remote-developer/Hire-remote-developer.jpg')
};

export const HIRE_DEVELOPMENT_TEAM_META_DATA: PageHeadMeta = {
    title: 'Hire Development Team | Dedicated Software Development Team',
    img: cdnUrl('Hire-team/Hire-Dedicated-Development-Team.jpg'),
    description:
        'Hire a dedicated development team to boost your project success. Our certified experts specialize in custom software development, web applications, and more.'
};

export const HIRE_BLOCKCHAIN_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Blockchain Developers | Blockchain Developers for Hire',
    img: cdnUrl('Hire-Blockchain-developer/Hire-blockchain-developer.jpg'),
    description:
        'Hire top blockchain developers to transform your ideas into reality! From smart contracts to dApps, we create secure and scalable blockchain solutions.'
};

export const HIRE_DOT_NET_DATA: PageHeadMeta = {
    title: 'Hire .Net Developers | Hire Dedicated .Net Developer',
    img: cdnUrl('Hire-dot-net-developer/Hire-dot-net-developer.jpg'),
    description:
        'Hire .NET developers to create secure, scalable web apps. Our dedicated .NET programmers are available on an hourly or full-time basis to meet your project needs.'
};

export const HIRE_PROMPT_ENGINEERS: PageHeadMeta = {
    title: 'Hire Prompt Engineers | Dedicated AI Prompt Experts',
    description:
        'Hire expert prompt engineers to optimize AI performance. We have dedicated experts for custom AI prompts, automation, and NLP solutions.',
    img: cdnUrl('Hire-Prompt-engineer/Hire-Prompt-Engineers.jpg')
};

export const HIRE_MACHINE_LEARNING_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Machine Learning Engineers | Expert ML Developers',
    description:
        'Looking to hire skilled machine learning engineers? Hire our expert ML developers to build intelligent solutions that drive innovation and enhance business outcomes.',
    img: cdnUrl('Hire-Machine-Learning-Engineers/Hire-Machine-Learning-Engineers.jpg')
};

export const HIRE_MOBILE_APP_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Mobile App Developers | Hire App Developers',
    description:
        'Looking to hire skilled mobile app developers? Get expert developers for iOS, Android, and cross-platform apps to bring your vision to life.',
    img: cdnUrl('Hire-mobile-app-developers/Hire-Mobile-App-Developers.jpg')
};

export const HIRE_REACT_NATIVE_DEVELOPERS: PageHeadMeta = {
    title: 'Hire React Native Developers | Hire Remote React Native Developers',
    description:
        'Hire top React Native developers to build high-performing mobile apps. Flexible hiring models, cost-effective solutions, and faster time-to-market.',
    img: cdnUrl('Hire-React-Native/Hire-React-Native-Developers.jpg')
};

export const HIRE_REACTJS_DEVELOPERS: PageHeadMeta = {
    title: 'Hire ReactJS Developers',
    description:
        'Hire ReactJS developers in just 48 hours. Get scalable UI solutions built by skilled experts with 5+ years of hands-on React development experience.',
    img: cdnUrl('hire-reactJs/hire-Reactjs-developer.jpg')
};

export const HIRE_WEARABLE_APP_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Wearable App Developers',
    description:
        'Hire expert wearable app developers to build smart, scalable apps for fitness, healthcare, and lifestyle. Get tailored solutions for your wearable tech.',
    img: cdnUrl('Hire-Wearable-App/Hire-Wearable-App-Developers.jpg')
};

export const HIRE_WEB_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Web App Developers | Hire Remote Web Developers',
    description:
        'Hire experienced web developers to build scalable, secure, and custom web apps tailored to your business needs. Get started with top talent today!',
    img: cdnUrl('Hire-web-developers/Hire-Web-Developers.jpg')
};

export const HIRE_ANDROID_APP_DEVELOPERS_META_DATA: PageHeadMeta = {
    title: 'Hire Android App Developers | Android Developers For Hire',
    img: cdnUrl('Hire-android-developer/Hire-Android-App-Developers.jpg'),
    description:
        'Hire Android app developers from the top 3% talent pool to build scalable, secure, and user-friendly mobile apps tailored to your business goals.'
};

export const HIRE_LARAVEL_META_DATA: PageHeadMeta = {
    title: 'Hire Dedicated Laravel Developers',
    img: cdnUrl('Hire-laravel-developers/Hire-Laravel-Developers.jpg'),
    description:
        'Hire dedicated Laravel developers for scalable, secure, and high-performing web applications. Get flexible engagement models and faster time-to-market.'
};

export const HIRE_SMART_CONTRACT_META_DATA: PageHeadMeta = {
    title: 'Hire Smart Contract Developers | Smart Contract Developers For Hire',
    img: cdnUrl('Hire-Smart-contract-developers/Hire-Smart-Contract-Developers.jpg'),
    description:
        'Hire smart contract developers from the top 3% talent pool to build secure, efficient, and scalable blockchain solutions for your business.'
};

export const HIRE_AI_AGENTS_DEVELOPERS: PageHeadMeta = {
    title: 'Hire AI Agent Developers | Debut Infotech',
    description:
        'Hire the top 3% of AI agent engineers to build autonomous, intelligent agents that automate workflows, improve decisions, and accelerate business innovation.',
    img: cdnUrl('Hire-ai-agent-developer/Hire-AI-Agents-Developers.webp')
};

export const HIRE_FULL_STACK_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Full Stack Developers',
    description:
        'Hire dedicated full-stack developers offering 24/7 support, scalable architecture, and expert execution. Build high-quality apps faster with our team.',
    img: cdnUrl('hire-full-stack-developer/Hire-Full-Stack-Developers.jpg')
};

export const HIRE_SAAS_DEVELOPERS: PageHeadMeta = {
    title: 'Hire SaaS Developers in India',
    description:
        'Hire SaaS developers from Debut Infotech to build scalable, secure SaaS products with proven expertise, faster delivery, and business-focused results!',
    img: cdnUrl('Hire-SaaS-Developers/Hire-SaaS-Developers.jpg')
};

export const Hire_FLUTTER_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Dedicated Flutter Developers in India',
    description:
        'Hire dedicated Flutter developers from Debut Infotech to build high-performance, cross-platform apps with faster delivery, clean code, and scalable architecture.',
    img: cdnUrl('Hire-Flutter-developer/Hire-Flutter-Developers.jpg')
};

export const HIRE_DEFI_DEVELOPERS: PageHeadMeta = {
    title: 'Hire DeFi Developers',
    img: cdnUrl('hire-defi-developers/Hire-DeFi-Developers.jpg'),
    description:
        'Hire certified DeFi developers with 10+ years of blockchain expertise to build secure, scalable DeFi platforms and smart contracts.'
};

export const HIRE_IOS_DEVELOPERS: PageHeadMeta = {
    title: 'Hire iOS Developers in India | Hire Remote iOS Developer',
    img: cdnUrl('Hire-ios-developers/Hire-iOS-Developers.jpg'),
    description:
        'Hire remote iOS developers in India to build high-performance iPhone and iPad apps. Flexible hiring models, proven expertise, and reliable delivery.'
};

export const HIRE_NODEJS_DEVELOPERS: PageHeadMeta = {
    title: 'Hire Dedicated Node.js Developers',
    img: cdnUrl('Hire-Node-js-Developers/Hire-Dedicated-Nodejs-Developers .jpg'),
    description:
        'Hire dedicated Node.js developers to build scalable, secure, and high-performance applications tailored to your business goals and timelines.'
};
